<form
  [formGroup]="resetPasswordForm"
  (ngSubmit)="onSubmit()"
  #resetForm="ngForm"
  id="frmResetPassword"
>
  <div class="u-background-color-white u-padding-15">
    <div fxLayout="row wrap" fxLayoutGap="15px grid" fxLayoutAlign="start end">
      <div fxFlex="100" fxFlex.gt-sm="33" fxFlex.gt-md="25" fxFlex.gt-lg="20">
        <mat-form-field class="mat-block" id="matFrmOldPassword">
          <input
            type="password"
            id="txtOldPassword"
            matInput
            [placeholder]="'profile.old_password' | translate"
            formControlName="oldPassword"
            (keydown)="noWhiteSpaceAllow($event)"
            required
          />
          <mat-error
            class="error-message"
            id="matErrRequiredOldPassword"
            *ngIf="((resetPasswordForm.get('oldPassword').dirty ||
          resetPasswordForm.get('oldPassword').touched) && resetPasswordForm.get('oldPassword').hasError('required'))"
          >
            {{ "profile.old_password_validation" | translate }}
          </mat-error>
        </mat-form-field>
      </div>
      <div fxFlex="100" fxFlex.gt-sm="33" fxFlex.gt-md="25" fxFlex.gt-lg="20">
        <mat-form-field class="mat-block" id="matFrmNewPassword">
          <input
            type="password"
            id="txtNewPassword"
            matInput
            [placeholder]="'profile.new_password' | translate"
            formControlName="newPassword"
            (keydown)="noWhiteSpaceAllow($event)"
            required
          />
          <mat-error
            class="error-message"
            id="matErrRequiredNewPassword"
            *ngIf="((resetPasswordForm.get('newPassword').dirty ||
          resetPasswordForm.get('newPassword').touched ) && resetPasswordForm.get('newPassword').hasError('required'))"
          >
            {{ "profile.new_password_validation" | translate }}
          </mat-error>
          <mat-error
            class="error-message"
            id="matErrPatternNewPassword"
            *ngIf="((resetPasswordForm.get('newPassword').dirty ||
          resetPasswordForm.get('newPassword').touched ) && resetPasswordForm.get('newPassword').hasError('pattern'))"
          >
            {{ "profile.password_invalid" | translate }}
          </mat-error>
        </mat-form-field>
      </div>
      <div fxFlex="100" fxFlex.gt-sm="33" fxFlex.gt-md="25" fxFlex.gt-lg="20">
        <mat-form-field class="mat-block" id="matFrmConfirmPassword">
          <input
            type="password"
            id="txtConfirmPassword"
            matInput
            [placeholder]="'profile.confirm_password' | translate"
            formControlName="confirmPassword"
            (keydown)="noWhiteSpaceAllow($event)"
          />
          <mat-error
            class="error-message"
            id="matErrMismatchConfirmPassword"
            *ngIf="((resetPasswordForm.get('confirmPassword').dirty ||
          resetPasswordForm.get('confirmPassword').touched ) && resetPasswordForm.get('confirmPassword').hasError('mustMatch'))"
          >
            {{ "profile.password_mismatch" | translate }}
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </div>
  <div class="c-bottom-action-bar u-text-right">
    <button
      mat-flat-button
      color="primary"
      type="submit"
      id="btnSave"
      [disabled]="resetPasswordForm.invalid"
    >
      {{ "profile.save" | translate }}
    </button>
    <button mat-flat-button color="warn" type="button" (click)="cancel()" id="btnCancel">
      {{ "profile.cancel" | translate }}
    </button>
  </div>
</form>
